




import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { FilterComponentMixin } from '@/mixins/filter-component.mixin'
import { Moment } from 'moment'

@Component
export default class DatePicker extends mixins(FilterComponentMixin) {
  get value() {
    const { value } = this.filter
    return value ? this.$moment(value) : undefined
  }

  set value(date: Moment | undefined) {
    this.$set(this.filter, 'value', date ? date.format() : undefined)
  }
}
